import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/login";
import Signup from "./pages/signup";
import GameHome from "./pages/GameHome";
import ForgotPassword from "./pages/forgotpassword";
import ResetPassword from "./pages/resetpassword";
import ChangePassword from "./pages/changepassword";
import Profile from "./pages/profile";
import NflSurvivorHome from "./pages/NflSurvivorHome";
import NflSurvivorPoolSetup from "./pages/NflSurvivorPoolSetup";
import NflSurvivorActiveHome from "./pages/NflSurvivorActiveHome";
import NflPickemActiveHome from "./pages/NflPickemActiveHome";
import NflPickemDivisionsPage from "./pages/NflPickemDivisionsPage";
import NflPickemHome from "./pages/NflPickemHome";
import NflPickemPicksPage from "./pages/NflPickemPicksPage";
import NflPickemAllPicksPage from "./pages/NflPickemAllPicksPage";
import NflPickemPoolSetup from "./pages/NflPickemPoolSetup";
import NflSurvivorPicksPage from "./pages/NflSurvivorPicksPage";
import PremierLeagueHome from "./pages/premierleaguehome";
import PremierLeagueActiveHome from "./pages/premierleagueactivehome";
import PlAllPicksPage from "./pages/PlAllPicksPage";
import RequireAuth from "./auth/RequireAuth";
import PremierLeaguePickPage from "./pages/premierleaguepickpage";
import TablePredictorPage from "./pages/TablePredictorPage";
import MlbHrDerbyHome from "./pages/MlbHrDerbyHome";
import MlbHrDerbyActiveHome from "./pages/MlbHrDerbyActiveHome";
import MlbHrDerbyRostersView from "./pages/MlbHrDerbyRostersView";
import MlbHrDerbySwapPage from "./pages/MlbHrDerbySwapPage";
import MlbHrDerbyDraftPage from "./pages/MlbHrDerbyDraftPage";
import WorldCupHome from "./pages/WorldCupHome";
import WorldCupPoolSetup from "./pages/WorldCupPoolSetup";
import WorldCupActiveHome from "./pages/WorldCupActiveHome";
import WorldCupSwapPage from "./pages/WorldCupSwapPage";
import PLPoolSetup from "./pages/PLPoolSetup";
import MlbHrDerbyPoolSetup from "./pages/MlbHrDerbyPoolSetup";
import MlbPlayoffHome from "./pages/MlbPlayoffHome";
import MlbPlayoffActiveHome from "./pages/MlbPlayoffActiveHome";
import MlbPlayoffDraftPage from "./pages/MlbPlayoffDraftPage";
import MlbPlayoffRostersView from "./pages/MlbPlayoffRostersView";
import MlbPlayoffPoolSetup from "./pages/MlbPlayoffPoolSetup";
import MyPoolsPage from "./pages/MyPoolsPage";
import JoinPage from "./pages/JoinPage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/join/:token" element={<JoinPage />} />

      <Route
        path="/"
        element={
          <RequireAuth>
            <GameHome />
          </RequireAuth>
        }
      />

      <Route
        path="/my-pools"
        element={
          <RequireAuth>
            <MyPoolsPage />
          </RequireAuth>
        }
      />

      <Route
        path="/change-password"
        element={
          <RequireAuth>
            <ChangePassword />
          </RequireAuth>
        }
      />

      <Route
        path="/profile"
        element={
          <RequireAuth>
            <Profile />
          </RequireAuth>
        }
      />

      <Route
        path="/premier-league"
        element={
          <RequireAuth>
            <PremierLeagueHome />
          </RequireAuth>
        }
      />

      <Route
        path="/premier-league/current/:poolId"
        element={
          <RequireAuth>
            <PremierLeagueActiveHome />
          </RequireAuth>
        }
      />

      <Route
        path="/premier-league/all-picks/:poolId"
        element={
          <RequireAuth>
            <PlAllPicksPage />
          </RequireAuth>
        }
      />

      <Route
        path="/premier-league/setup/:poolId"
        element={
          <RequireAuth>
            <PLPoolSetup />
          </RequireAuth>
        }
      />

      <Route
        path="/premier-league/picks/:poolId"
        element={
          <RequireAuth>
            <PremierLeaguePickPage />
          </RequireAuth>
        }
      />

      <Route
        path="/premier-league/table-predictor/:poolId"
        element={
          <RequireAuth>
            <TablePredictorPage />
          </RequireAuth>
        }
      />

      <Route
        path="/mlb-hr-derby"
        element={
          <RequireAuth>
            <MlbHrDerbyHome />
          </RequireAuth>
        }
      />

      <Route
        path="/mlb-hr-derby/current/:poolId"
        element={
          <RequireAuth>
            <MlbHrDerbyActiveHome />
          </RequireAuth>
        }
      />

      <Route
        path="/mlb-hr-derby/setup/:poolId"
        element={
          <RequireAuth>
            <MlbHrDerbyPoolSetup />
          </RequireAuth>
        }
      />

      <Route
        path="/mlb-hr-derby/current/:poolId/rosters"
        element={
          <RequireAuth>
            <MlbHrDerbyRostersView />
          </RequireAuth>
        }
      />

      <Route
        path="/mlb-hr-derby/current/:poolId/swap"
        element={
          <RequireAuth>
            <MlbHrDerbySwapPage />
          </RequireAuth>
        }
      />

      <Route
        path="/mlb-hr-derby/current/:poolId/draft"
        element={
          <RequireAuth>
            <MlbHrDerbyDraftPage />
          </RequireAuth>
        }
      />

      <Route
        path="/world-cup"
        element={
          <RequireAuth>
            <WorldCupHome />
          </RequireAuth>
        }
      />

      <Route
        path="/world-cup/setup/:poolId"
        element={
          <RequireAuth>
            <WorldCupPoolSetup />
          </RequireAuth>
        }
      />

      <Route
        path="/world-cup/current/:poolId"
        element={
          <RequireAuth>
            <WorldCupActiveHome />
          </RequireAuth>
        }
      />

      <Route
        path="/world-cup/current/:poolId/swap"
        element={
          <RequireAuth>
            <WorldCupSwapPage />
          </RequireAuth>
        }
      />

      <Route
        path="/mlb-playoff"
        element={
          <RequireAuth>
            <MlbPlayoffHome />
          </RequireAuth>
        }
      />

      <Route
        path="/mlb-playoff/current/:poolId"
        element={
          <RequireAuth>
            <MlbPlayoffActiveHome />
          </RequireAuth>
        }
      />

      <Route
        path="/mlb-playoff/current/:poolId/draft"
        element={
          <RequireAuth>
            <MlbPlayoffDraftPage />
          </RequireAuth>
        }
      />

      <Route
        path="/mlb-playoff/current/:poolId/rosters"
        element={
          <RequireAuth>
            <MlbPlayoffRostersView />
          </RequireAuth>
        }
      />

      <Route
        path="/mlb-playoff/setup/:poolId"
        element={
          <RequireAuth>
            <MlbPlayoffPoolSetup />
          </RequireAuth>
        }
      />


      <Route
        path="/nfl-survivor"
        element={
          <RequireAuth>
            <NflSurvivorHome />
          </RequireAuth>
        }
      />
      <Route
        path="/nfl-survivor/setup/:poolId"
        element={
          <RequireAuth>
            <NflSurvivorPoolSetup />
          </RequireAuth>
        }
      />
      <Route
        path="/nfl-survivor/current/:poolId"
        element={
          <RequireAuth>
            <NflSurvivorActiveHome />
          </RequireAuth>
        }
      />
      <Route
        path="/nfl-survivor/picks/:poolId"
        element={
          <RequireAuth>
            <NflSurvivorPicksPage />
          </RequireAuth>
        }
      />

      <Route
        path="/nfl-pickem"
        element={
          <RequireAuth>
            <NflPickemHome />
          </RequireAuth>
        }
      />

      <Route
        path="/nfl-pickem/current/:poolId"
        element={
          <RequireAuth>
            <NflPickemActiveHome />
          </RequireAuth>
        }
      />

      <Route
        path="/nfl-pickem/divisions/:poolId"
        element={
          <RequireAuth>
            <NflPickemDivisionsPage />
          </RequireAuth>
        }
      />

      <Route
        path="/nfl-pickem/setup/:poolId"
        element={
          <RequireAuth>
            <NflPickemPoolSetup />
          </RequireAuth>
        }
      />

      <Route
        path="/nfl-pickem/picks/:poolId"
        element={
          <RequireAuth>
            <NflPickemPicksPage />
          </RequireAuth>
        }
      />

      <Route
        path="/nfl-pickem/all-picks/:poolId"
        element={
          <RequireAuth>
            <NflPickemAllPicksPage />
          </RequireAuth>
        }
      />

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}